/* eslint-disable no-magic-numbers */
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-car-color',
  templateUrl: './car-color.component.html',
  styleUrls: ['./car-color.component.scss',],
})
export class CarColorComponent implements OnInit {

  @Input() colorName?: string;
  @Input() colorCode?: string;
  @Input() invertedColorCode?: string;

  constructor() { }

  ngOnInit(): void {
    this.invertedColorCode = this.invertColor(this.colorCode);
  }

  invertColor(hex: any, bw?: any) {
    if (hex.indexOf('#') === 0) {
      hex = hex.slice(1);
    } else { return; }

    const rInt = parseInt(hex.slice(0, 2), 16),
      gInt = parseInt(hex.slice(2, 4), 16),
      bInt = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      return (rInt * 0.299 + gInt * 0.587 + bInt * 0.114) > 140
        ? '#000000'
        : '#FFFFFF';
    }
    const r = (255 - rInt).toString(16);
    const g = (255 - gInt).toString(16);
    const b = (255 - bInt).toString(16);
    return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b);
  }

  padZero(str: string, len: number = 2) {
    const zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  }

}
